import { List } from "immutable";

import { compose } from "seneca-common/utils/functions/compose";

import Content from "../../../../models/state/contents/content/Content";
import ContentOptions from "../../../../models/state/contents/content/options/ContentOptions";
import { ModuleId } from "../../../../models/state/modules/module/ContentModule";
import * as options from "./options";

export function getId(content: Content) {
  return content.id;
}
export function getParentId(content: Content) {
  return content.parentId;
}
export function getTags(content: Content): List<string> {
  return content.tags;
}
export function getPrereqTags(content: Content): List<string> {
  return content.prereqTags;
}
export function getContentModuleIds(content: Content): List<ModuleId> {
  return content.contentModuleIds;
}
export function getOptions(content: Content): ContentOptions {
  return content.options;
}

type IsSequential = (content: Content) => boolean;
export const isSequential: IsSequential = compose(
  options.isSequential,
  getOptions
);

type IsExercise = (content: Content) => boolean;
export const isExercise: IsExercise = compose(options.isExercise, getOptions);

export function getLastContentModuleId(content: Content): ModuleId {
  return getContentModuleIds(content).last();
}

export function contentModuleIdIsLastInContent(
  content: Content,
  moduleId: ModuleId
): boolean {
  return moduleId === getLastContentModuleId(content);
}

export function getContentModuleIndex(
  content: Content,
  moduleId: ModuleId
): number {
  return getContentModuleIds(content).indexOf(moduleId);
}

export function getContentModuleIdAtIndex(content: Content, index: number) {
  return getContentModuleIds(content).get(index);
}

export function getFirstContentModuleId(content: Content): ModuleId {
  return getContentModuleIds(content).first();
}

export function getFollowingContentModuleId(
  content: Content,
  moduleId: ModuleId
) {
  const index = getContentModuleIndex(content, moduleId);
  return getContentModuleIdAtIndex(content, index + 1);
}

export function includesContentModuleId(
  content: Content,
  moduleId: ModuleId
): boolean {
  return getContentModuleIds(content).includes(moduleId);
}
